import Task from "@homer.core/task";

function stringify(identifier, resolve, reject, value) {
    resolve(JSON.stringify(value));
}

export default new Task(stringify);
